import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgClass } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Optional, Output, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatError,
  MatFormField,
  MatHint,
  MatLabel,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicTextAreaModel,
} from '@ng-dynamic-forms/core';
import { DynamicMaterialFormInputControlComponent } from '../dynamic-material-form-input-control.component';

@Component({
  selector: 'dynamic-material-textarea',
  templateUrl: './dynamic-material-textarea.component.html',
  imports: [MatFormField, ReactiveFormsModule, NgClass, MatLabel, MatInput, CdkTextareaAutosize, MatHint, MatError],
})
export class DynamicMaterialTextAreaComponent extends DynamicMaterialFormInputControlComponent {
  @Input() formLayout: DynamicFormLayout;
  @Input() group: FormGroup;
  @Input() layout: DynamicFormControlLayout;
  @Input() model: DynamicTextAreaModel;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatInput, { static: true }) matInput: MatInput;

  inputHasValue = false;
  isFocus = false;

  checkInput(input: string) {
    this.inputHasValue = input ? true : false;
  }

  ifFocus(event: string) {
    this.isFocus = event ? true : false;
  }

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService,
    @Inject(MAT_FORM_FIELD_DEFAULT_OPTIONS) @Optional() public LABEL_OPTIONS: any
  ) {
    super(layoutService, validationService);
  }
}
